// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"ea50540c","264":"8b196fd1","312":"444c54f7","453":"59151c8a","559":"21e1c72e","773":"e80a0a9e","820":"460984db","829":"38fbdfa5"}[chunkId] + ".chunk.js";
};